module.exports = __webpack_public_path__ + "static/media/arrow-left.5f142128.svg";